export const radius = {
    radius_2: "2px",
    radius_4: "4px",
    radius_6: "6px",
    radius_8: "8px",
    radius_10: "10px",
    radius_12: "12px",
    radius_16: "16px",
    radius_20: "20px",
    radius_24: "24px",
    radius_28: "28px",
    radius_32: "32px",
    radius_40: "40px",
    radius_46: "46px",
    radius_rounded: "100px"
};
